/* unplugin-vue-components disabled */import script from "./TimeChange.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeChange.vue?vue&type=script&setup=true&lang=js"

import "./TimeChange.vue?vue&type=style&index=0&id=15bcac7a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15bcac7a"]])

export default __exports__